import File from './Items/File';
import Folder from './Items/Folder';
import SearchItem from './Items/SearchItem';
import NoResultPage from './NoResultPage';
import {  List, Divider  } from "@mui/material";
import Breadcrumbs from './Breadcrumbs/Breadcrumbs';
import { ContentContext } from "../../../../utils/contexts";
import { PathPickerType } from "../../../../types/enums";
import Loader from '../../../../../Loader';

class ItemList extends React.PureComponent {
	render() {
		const { content, loadingContent, breadcrumbs, searchMode, switchValue, searchQuery } = this.context;

		const listSx = {
			minHeight: '200px',
			...(loadingContent && { filter: 'blur(3px)' }),
		};

		return (
			<div className='Item-List'>
				{breadcrumbs.length > 0 && (searchQuery === "" || (!switchValue && searchQuery !== "")) && (
					<>
						<Divider />
						<Breadcrumbs />
						<Divider />
					</>
				)}
				<div className="List-Wrapper">
					{loadingContent && <Loader />}
					{content.length > 0 && (
						<List sx={listSx} disablePadding>
							{content.map((item, index) =>
									/*searchMode ? <SearchItem key={item.nodeRef} item={item} index={index} /> :*/ item.type === PathPickerType.FOLDER ? (
									<Folder key={item.nodeRef} item={item} index={index} />
								) : (
									<File key={item.nodeRef} item={item} index={index} />
								)
							)}
						</List>
					)}
					{content.length < 1 && <NoResultPage />}
				</div>
			</div>
		);
	}
}

ItemList.contextType = ContentContext;

export default ItemList;
